import '@css/app-page.css';
import './bootstrap';
import { createInertiaApp } from '@inertiajs/react';
import React from 'react';

import { getInertiaRoot } from '@/lib/inertiaRoot';
import { logger } from '@/lib/logger';
import { skipSelfReportingErrorBoundaries } from '@/lib/reactErrorBoundaryReporting';
import { initSentry, Sentry } from '@/lib/sentry';
import { PageRenderProfile } from '@/types/enums';

import { resolvePageComponent } from './pageAppResolver';

async function boot() {
  const isPrintProfile = document.documentElement.dataset.renderProfile === PageRenderProfile.Print;
  void initSentry({ enableReplay: !isPrintProfile });

  createInertiaApp({
    resolve: resolvePageComponent,
    serverHead: 'serverHead',
    setup({ el, App, props }) {
      const root = getInertiaRoot(el, {
        onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
          logger.error('[React] Uncaught error', {
            error,
            context: { componentStack: errorInfo.componentStack }
          });
        }),
        onCaughtError: skipSelfReportingErrorBoundaries(
          Sentry.reactErrorHandler((error, errorInfo) => {
            logger.error('[React] Caught error', {
              error,
              context: { componentStack: errorInfo.componentStack }
            });
          })
        ),
        onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
          logger.error('[React] Recoverable error', {
            error,
            context: { componentStack: errorInfo.componentStack }
          });
        })
      });

      root.render(
        <React.StrictMode>
          <App {...props} />
        </React.StrictMode>
      );
    },
    progress: {
      color: '#4B5563'
    }
  });
}

void boot();
